/**
 * Custom storefront JS for 3NODE / Realfoot.
 *
 * Keep this file small and scoped. Use IIFEs with their own selectors and
 * a "processed" flag so each tweak is idempotent (safe to re-run on DOM
 * mutations, theme editor re-renders, SPA navigations).
 *
 * Load order: deferred, after DOM is parsed, via snippets/scripts.liquid.
 */

/* =============================================================
   Texty, které skládá tenhle soubor — podle jazyka stránky.
   Web běží v cs (výchozí), en a de; dřív byly texty napevno česky
   a na /en i /de svítila čeština (Freelo 32356935). Neznámý jazyk
   spadne na angličtinu. Nový text přidat sem, ne do kódu níž.
   ============================================================= */
var RF_TEXTY = (function () {
  var lang = (document.documentElement.lang || 'cs').slice(0, 2).toLowerCase();
  var slovnik = {
    cs: {
      hodnoceni: 'Hodnocení',
      vymazatFiltry: 'Vymazat filtry',
      vyberteVelikost: 'Vyberte velikost',
      hlidat: 'Hlídat',
      naZaklade: function (n) { return 'na základě ' + n + ' recenzí '; },
      naZakladeHtml: function (n) { return 'na základě <strong>' + n + ' recenzí</strong>'; },
      spokojeni: 'našich spokojených zákazníků ',
      kbite: {
        dostupnost: {
          heading: 'Hlídat dostupnost',
          subheading: 'Ozveme se vám e-mailem, jakmile bude zboží zpátky skladem.',
          notifyButtonTitle: 'Chci hlídat'
        },
        cena: {
          heading: 'Hlídat cenu',
          subheading: 'Ozveme se vám e-mailem, jakmile produkt zlevní.',
          notifyButtonTitle: 'Chci hlídat'
        },
        privacyText: 'Vaši e-mailovou adresu použijeme jen pro toto upozornění a nikomu ji nepředáváme.',
        emailPlaceholder: 'E-mailová adresa',
        successText: 'Hotovo, hlídáme. Ozveme se e-mailem.',
        successCloseText: 'Zavřít',
        zavrit: 'Zavřít',
        chyby: {
          'Please Provide Valid Email': 'Zadejte prosím platnou e-mailovou adresu.',
          'Please Select Country': 'Vyberte prosím zemi.',
          'Please Provide Valid Contact Number': 'Zadejte prosím platné telefonní číslo.'
        }
      }
    },
    en: {
      hodnoceni: 'Rating',
      vymazatFiltry: 'Clear filters',
      vyberteVelikost: 'Select size',
      hlidat: 'Notify me',
      naZaklade: function (n) { return 'based on ' + n + ' reviews '; },
      naZakladeHtml: function (n) { return 'based on <strong>' + n + ' reviews</strong>'; },
      spokojeni: 'from our happy customers ',
      kbite: {
        dostupnost: {
          heading: 'Notify me when available',
          subheading: 'We will email you as soon as this item is back in stock.',
          notifyButtonTitle: 'Notify me'
        },
        cena: {
          heading: 'Notify me when the price drops',
          subheading: 'We will email you as soon as the price drops.',
          notifyButtonTitle: 'Notify me'
        },
        privacyText: 'We will only use your email for this alert and never share it with anyone.',
        emailPlaceholder: 'Email address',
        successText: 'Done. We will email you as soon as it is back.',
        successCloseText: 'Close',
        zavrit: 'Close',
        chyby: {
          'Please Provide Valid Email': 'Please enter a valid email address.',
          'Please Select Country': 'Please select a country.',
          'Please Provide Valid Contact Number': 'Please enter a valid phone number.'
        }
      }
    },
    de: {
      hodnoceni: 'Bewertung',
      vymazatFiltry: 'Filter löschen',
      vyberteVelikost: 'Größe wählen',
      hlidat: 'Benachrichtigen',
      naZaklade: function (n) { return 'basierend auf ' + n + ' Bewertungen '; },
      naZakladeHtml: function (n) { return 'basierend auf <strong>' + n + ' Bewertungen</strong>'; },
      spokojeni: 'unserer zufriedenen Kunden ',
      kbite: {
        dostupnost: {
          heading: 'Verfügbarkeit beobachten',
          subheading: 'Wir benachrichtigen Sie per E-Mail, sobald der Artikel wieder auf Lager ist.',
          notifyButtonTitle: 'Benachrichtigen'
        },
        cena: {
          heading: 'Preis beobachten',
          subheading: 'Wir benachrichtigen Sie per E-Mail, sobald der Preis sinkt.',
          notifyButtonTitle: 'Benachrichtigen'
        },
        privacyText: 'Wir verwenden Ihre E-Mail-Adresse nur für diese Benachrichtigung und geben sie nicht weiter.',
        emailPlaceholder: 'E-Mail-Adresse',
        successText: 'Erledigt. Wir melden uns per E-Mail.',
        successCloseText: 'Schließen',
        zavrit: 'Schließen',
        chyby: {
          'Please Provide Valid Email': 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
          'Please Select Country': 'Bitte wählen Sie ein Land.',
          'Please Provide Valid Contact Number': 'Bitte geben Sie eine gültige Telefonnummer ein.'
        }
      }
    }
  };
  return slovnik[lang] || slovnik.en;
})();

/* Kopie oznamovací lišty na spodku mobilního menu je pryč
   (připomínky 21. 9., #45) — lišta je na stránce nahoře a v menu jen
   zabírala místo. Spolu s ní zmizel i MutationObserver nad celým
   dokumentem, který ji hlídal. */

/* =============================================================
   Judge.me Cards Carousel — DOM reorganizer.
   The Judge.me app block renders:
     .jdgm-header  (title + header-info)
     .jdgm-content (arrows + cards wrapper)
   We move .jdgm-header-info into .jdgm-content, inside a new
   .jdgm-header-info-wrapper div. That lets CSS lay out the
   info block as a sidebar next to the cards (Figma layout).
   Idempotent via data-3n-reorganized.
   ============================================================= */
(function () {
  'use strict';

  var SELECTOR = '.jdgm-horizon-widget[data-block-handle="cards_carousel"]';
  var PROCESSED_ATTR = 'data-3n-reorganized';
  var WRAPPER_CLASS = 'jdgm-header-info-wrapper';

  function reorganize(widget) {
    if (widget.hasAttribute(PROCESSED_ATTR)) return;
    var headerInfo = widget.querySelector('.jdgm-header-info');
    var content = widget.querySelector('.jdgm-content');
    if (!headerInfo || !content) return;
    // Skip if a wrapper is already there (e.g. re-run on same DOM).
    if (content.querySelector('.' + WRAPPER_CLASS)) {
      widget.setAttribute(PROCESSED_ATTR, '');
      return;
    }
    var wrapper = document.createElement('div');
    wrapper.className = WRAPPER_CLASS;
    // Put header-info inside the wrapper, then put the wrapper as the
    // first child of .jdgm-content (before the arrows and cards).
    wrapper.appendChild(headerInfo);
    content.prepend(wrapper);
    widget.setAttribute(PROCESSED_ATTR, '');
  }

  function run() {
    document.querySelectorAll(SELECTOR).forEach(reorganize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // Re-run when Judge.me or Shopify later mutates the DOM (e.g. theme
  // editor section re-render, async app-block hydration).
  new MutationObserver(run).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();

/* =============================================================
   Judge.me Cards Carousel — header-info redesign to Figma.
   Replaces:
     stars + "4.84 ★ (1,844)" + verified badge
   with a centered column:
     4.84            (big number)
     ★★★★★          (stars, resized via CSS)
     na základě 1,844 recenzí
     našich spokojených zákazníků

   Judge.me's .jdgm-rating-text contains "4.84 ★ (1,844)" as a single
   text node, so CSS alone can't split it. We parse it, build new
   elements, and hide the originals. Idempotent via data-3n-header-v2.
   ============================================================= */
(function () {
  'use strict';

  var WIDGET_SELECTOR =
    '.jdgm-horizon-widget[data-block-handle="cards_carousel"]';
  var PROCESSED_ATTR = 'data-3n-header-v2';

  function transformHeader(widget) {
    if (widget.hasAttribute(PROCESSED_ATTR)) return;

    var info = widget.querySelector('.jdgm-header-info');
    if (!info) return;

    var avgRating = info.querySelector('.jdgm-average-rating');
    var ratingText = info.querySelector('.jdgm-rating-text');
    var countEl = info.querySelector('.jdgm-reviews-count');
    if (!avgRating || !ratingText || !countEl) return;

    // Parse average from "4.84 ★ (1,844)" and round to 1 decimal place
    // (e.g. "4.84" -> "4.8").
    var m = (ratingText.textContent || '').match(/([\d.,]+)/);
    if (!m) return;
    var avgNum = parseFloat(m[1].replace(',', '.'));
    var avg = isNaN(avgNum) ? m[1] : avgNum.toFixed(1);
    var count = (countEl.textContent || '').trim();

    // Figma header: a ROW of [left column: number + stars] + [uppercase headline].
    var bigNumber = document.createElement('div');
    bigNumber.className = 'jdgm-big-number';
    bigNumber.textContent = avg;

    var leftCol = document.createElement('div');
    leftCol.className = 'jdgm-rating-col';

    // Headline flows as one sentence (inline spans) so it wraps naturally.
    var headline = document.createElement('div');
    headline.className = 'jdgm-rating-headline';

    var basedOn = document.createElement('span');
    basedOn.className = 'jdgm-based-on';
    basedOn.textContent = RF_TEXTY.naZaklade(count);

    var happy = document.createElement('span');
    happy.className = 'jdgm-happy-customers';
    happy.textContent = RF_TEXTY.spokojeni;

    var realtalk = document.createElement('span');
    realtalk.className = 'jdgm-realtalk';
    realtalk.textContent = '#realtalk';

    headline.appendChild(basedOn);
    headline.appendChild(happy);
    headline.appendChild(realtalk);

    var stars = avgRating.querySelector('.jdgm-stars');
    leftCol.appendChild(bigNumber);
    if (stars) leftCol.appendChild(stars);
    avgRating.appendChild(leftCol);
    avgRating.appendChild(headline);

    // Hide the original inline rating text and verified badge.
    ratingText.style.display = 'none';
    var verified = info.querySelector('.jdgm-verified-badge-header');
    if (verified) verified.style.display = 'none';

    widget.setAttribute(PROCESSED_ATTR, '');
  }

  function run() {
    document.querySelectorAll(WIDGET_SELECTOR).forEach(transformHeader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  new MutationObserver(run).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();

/* =============================================================
   Judge.me Cards Carousel — avatar with first letter of name.
   Judge.me doesn't render an avatar by default. We read the
   .jdgm-reviewer-name text and prepend a styled circle with the
   first letter (styled via .jdgm-avatar in custom.css.liquid).

   Idempotent via data-3n-avatar on the card; safe to re-run.
   ============================================================= */
(function () {
  'use strict';

  var CARD_SELECTOR =
    '.jdgm-horizon-widget[data-block-handle="cards_carousel"] .jdgm-card';
  var PROCESSED_ATTR = 'data-3n-avatar';

  function addAvatar(card) {
    if (card.hasAttribute(PROCESSED_ATTR)) return;
    var info = card.querySelector('.jdgm-reviewer-info');
    if (!info) return;
    // Skip if an avatar is already there (e.g. re-run on same DOM).
    if (info.querySelector('.jdgm-avatar')) {
      card.setAttribute(PROCESSED_ATTR, '');
      return;
    }
    var nameEl = info.querySelector('.jdgm-reviewer-name');
    if (!nameEl) return;
    var raw = (nameEl.textContent || '').trim();
    if (!raw) return;
    var initial = raw.charAt(0);
    var avatar = document.createElement('span');
    avatar.className = 'jdgm-avatar';
    avatar.textContent = initial;
    avatar.setAttribute('aria-hidden', 'true');
    info.insertBefore(avatar, nameEl);
    card.setAttribute(PROCESSED_ATTR, '');
  }

  function run() {
    document.querySelectorAll(CARD_SELECTOR).forEach(addAvatar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // Watch for late-hydrating widgets (theme editor re-render, async load).
  new MutationObserver(run).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();

/* =============================================================
   Size-chart drawer — right-side slide-in.
   Triggered by any [data-size-chart-open] button. Closes via any
   [data-size-chart-close] element (backdrop + X button) or Escape.
   Listeners are idempotent via a sentinel on <body>.
   ============================================================= */
(function () {
  'use strict';

  var DRAWER_ID = 'size-chart-drawer';
  var BODY_OPEN_CLASS = 'size-chart-drawer-open';
  var INIT_FLAG = 'data-3n-size-chart-init';

  function getDrawer() {
    return document.getElementById(DRAWER_ID);
  }

  function open() {
    var drawer = getDrawer();
    if (!drawer) return;
    // Remove `hidden` before aria-hidden so the browser shows the
    // element in the same tick the transition starts.
    drawer.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add(BODY_OPEN_CLASS);
  }

  function close() {
    var drawer = getDrawer();
    if (!drawer) return;
    drawer.hidden = true;
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove(BODY_OPEN_CLASS);
  }

  function init() {
    if (document.body.hasAttribute(INIT_FLAG)) return;
    document.body.setAttribute(INIT_FLAG, '');

    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-size-chart-open]');
      if (opener) {
        e.preventDefault();
        open();
        return;
      }
      var closer = e.target.closest('[data-size-chart-close]');
      if (closer) {
        e.preventDefault();
        close();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var drawer = getDrawer();
      if (drawer && drawer.getAttribute('aria-hidden') === 'false') {
        close();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* =============================================================
   Size-chart drawer — cm / inch unit toggle.
   Each .size-chart-table__row carries data-length-cm. Unchecked
   = cm (default), checked = inch. Inches rounded to 1 decimal;
   cm keeps source precision. Comma decimal separator for Czech
   number format.
   ============================================================= */
(function () {
  'use strict';

  var TAB = '[data-size-chart-unit]';
  var ROW = '.size-chart-table__row';
  var INIT_FLAG = 'data-3n-size-chart-units-init';

  function fmt(value, unit) {
    if (unit === 'cm') return (value || '').replace('.', ',');
    var n = parseFloat(value);
    if (isNaN(n)) return '';
    return (n / 2.54).toFixed(1).replace('.', ',');
  }

  function setUnit(unit) {
    var rows = document.querySelectorAll(ROW);
    rows.forEach(function (row) {
      var lenCm = row.getAttribute('data-length-cm');
      var lenCell = row.querySelector('[data-cell="length"]');
      if (lenCell) lenCell.textContent = fmt(lenCm, unit);
    });
    // reflect active tab state
    document.querySelectorAll(TAB).forEach(function (tab) {
      var on = tab.getAttribute('data-size-chart-unit') === unit;
      tab.classList.toggle('is-active', on);
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
    });
  }

  function init() {
    if (document.body.hasAttribute(INIT_FLAG)) return;
    document.body.setAttribute(INIT_FLAG, '');
    document.addEventListener('click', function (e) {
      var tab = e.target.closest(TAB);
      if (!tab) return;
      setUnit(tab.getAttribute('data-size-chart-unit'));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* =============================================================
   PDP section tabs — resolve suffix-match targets.

   Shopify wraps each rendered section in
     <div id="shopify-section-template--<TPL_ID>__<section-key>">
   so an anchor like `#shopify-section-product_info_section` won't
   resolve — only the template-prefixed full ID lives in the DOM.

   Rather than hardcoding the template prefix in templates/product.json
   (fragile — breaks if the template is reimported with a new internal
   id), this shim intercepts tab clicks and resolves the href by
   suffix match, then smooth-scrolls there.

   Supports both forms written into the block's target setting:
     shopify-section-product_info_section
     product_info_section
   ============================================================= */
(function () {
  'use strict';

  var INIT_FLAG = 'data-3n-pdp-tabs-init';

  function resolveTarget(rawId) {
    if (!rawId) return null;
    // Exact match first — covers any section whose ID happens to match verbatim.
    var el = document.getElementById(rawId);
    if (el) return el;
    // Strip the 'shopify-section-' prefix if present, then match the tail by suffix.
    var key = rawId.replace(/^shopify-section-/, '');
    return (
      document.querySelector('[id$="__' + CSS.escape(key) + '"]') ||
      document.querySelector('[id$="-' + CSS.escape(key) + '"]') ||
      null
    );
  }

  // Výška, kterou nahoře zabírá hlavička (jen když je zrovna vidět — režim
  // „scroll-up") + přilepená lišta záložek. O tolik se cíl posune pod ni.
  function headerOffset() {
    var h = document.querySelector('#header-component');
    if (!h) return 0;
    var r = h.getBoundingClientRect();
    return r.bottom > 0 ? Math.max(0, r.bottom) : 0;
  }

  function tabsSection() {
    var nav = document.querySelector('.pdp-section-tabs');
    return nav ? nav.closest('.shopify-section') : null;
  }

  function scrollToEl(target) {
    var sec = tabsSection();
    var barH = sec ? sec.getBoundingClientRect().height : 0;
    // Při sjezdu dolů se hlavička schová, nahoru se ukáže — počítáme s horší variantou.
    var hdr = document.querySelector('#header-component');
    var hdrH = hdr ? hdr.getBoundingClientRect().height : 0;
    var y = target.getBoundingClientRect().top + window.scrollY;
    var goingUp = y < window.scrollY;
    window.scrollTo({ top: Math.max(0, y - barH - (goingUp ? hdrH : 0) - 8), behavior: 'smooth' });
  }

  function onClick(e) {
    var link = e.target.closest('.pdp-section-tabs__link');
    if (!link) return;
    if (link.hasAttribute('data-pdp-tabs-top')) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
      if (history && history.replaceState) history.replaceState(null, '', location.pathname + location.search);
      return;
    }
    var href = link.getAttribute('href') || '';
    if (href.charAt(0) !== '#' || href.length < 2) return;
    var target = resolveTarget(href.slice(1));
    if (!target) return;
    e.preventDefault();
    scrollToEl(target);
    // Update the hash without forcing a jump.
    if (history && history.replaceState) {
      history.replaceState(null, '', href);
    }
  }

  /* Přilepená lišta + zvýraznění sekce, ve které právě jsme (Freelo 33471640).
     Sekce lišty je position: sticky (custom.css). Tady jen:
       - třída is-stuck, když lišta drží nahoře (ukáže „Nahoru", zmenší okraje),
       - --rf-pdp-tabs-top = spodek hlavičky, když je vidět, jinak 0,
       - aktivní záložka podle sekce pod lištou + posun pásu na mobilu. */
  function initSticky() {
    var sec = tabsSection();
    if (!sec) return;
    var nav = sec.querySelector('.pdp-section-tabs');
    var links = Array.prototype.slice.call(nav.querySelectorAll('.pdp-section-tabs__link:not([data-pdp-tabs-top])'));
    var items = links.map(function (a) {
      var href = a.getAttribute('href') || '';
      return { link: a, el: href.length > 1 ? resolveTarget(href.slice(1)) : null };
    }).filter(function (x) { return x.el; });
    var ticking = false, lastActive = null, pendingState = null, pendingTimer = null;

    // Přilepená lišta je nižší (menší tlačítka, bez odsazení). Rozdíl výšky se
    // vrací jako spodní okraj, ať obsah pod ní neposkočí.
    function applyStuck(stuck) {
      if (stuck === sec.classList.contains('is-stuck')) return;
      // Přechod je plynulý (CSS transition 0.25s). Cílovou výšku změříme bez
      // animace, pak vrátíme výchozí stav a pustíme přechod lišty i vyrovnávacího
      // okraje najednou — se stejnou křivkou se jejich součet nemění, obsah pod
      // lištou tedy stojí (Michal 27. 10.).
      var h0 = sec.getBoundingClientRect().height;
      var m0 = parseFloat(getComputedStyle(sec).marginBottom) || 0;
      sec.classList.add('rf-pdp-measure');
      sec.classList.toggle('is-stuck', stuck);
      var h1 = sec.getBoundingClientRect().height;
      sec.classList.toggle('is-stuck', !stuck);
      sec.getBoundingClientRect();
      sec.classList.remove('rf-pdp-measure');
      sec.style.marginBottom = m0 + 'px';
      sec.getBoundingClientRect();
      sec.classList.toggle('is-stuck', stuck);
      sec.style.marginBottom = Math.max(0, m0 + h0 - h1) + 'px';
    }

    function update() {
      ticking = false;
      var top = headerOffset();
      sec.style.setProperty('--rf-pdp-tabs-top', top + 'px');
      var r = sec.getBoundingClientRect();
      // Přilepená podle pozice scrollu, ne podle geometrie lišty (ta se při
      // přilepení mění a na hraně to blikalo). Hystereze: přilepí se až 32px za
      // svým místem, odlepí až 16px před ním — mezi tím zůstává, jak byla.
      // A změna se provede až po 150ms klidu (Michal 27. 10.).
      var prev = sec.previousElementSibling;
      var natural = prev ? prev.getBoundingClientRect().bottom + window.scrollY : 0;
      var pos = window.scrollY + top;
      var isStuck = sec.classList.contains('is-stuck');
      var want = isStuck ? pos > natural - 16 : pos > natural + 32;
      if (want !== isStuck) {
        if (pendingState !== want) {
          pendingState = want;
          clearTimeout(pendingTimer);
          pendingTimer = setTimeout(function () { pendingState = null; applyStuck(want); onScroll(); }, 150);
        }
      } else if (pendingState !== null) {
        pendingState = null;
        clearTimeout(pendingTimer);
      }
      var stuck = sec.classList.contains('is-stuck');

      // Aktivní = poslední sekce, jejíž začátek je nad spodkem lišty (+ rezerva).
      var line = r.bottom + 24, active = items.length ? items[0] : null;
      for (var i = 0; i < items.length; i++) {
        if (items[i].el.getBoundingClientRect().top <= line) active = items[i];
      }
      if (active && active !== lastActive) {
        links.forEach(function (a) { a.classList.toggle('pdp-section-tabs__link--active', a === active.link); });
        lastActive = active;
        if (stuck && nav.scrollWidth > nav.clientWidth) {
          var li = active.link.parentElement;
          nav.scrollTo({ left: Math.max(0, li.offsetLeft - 16), behavior: 'smooth' });
        }
      }
    }
    function onScroll() {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  function init() {
    if (document.body.hasAttribute(INIT_FLAG)) return;
    document.body.setAttribute(INIT_FLAG, '');
    document.addEventListener('click', onClick);
    initSticky();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* =============================================================
   PDP section tabs — review-count label on the "Recenze" tab.

   Rather than reading product.metafields.reviews.rating_count in
   Liquid (works but couples the tab block to a specific app's
   metafield keys), we just read whatever Judge.me already
   renders on the page. Look-up order:

     1. window.jdgm.data.allReviewsWidgetV2025.number_of_reviews
     2. any element with a `data-number-of-reviews` attribute
        (Judge.me's preview badge / review-widget hooks)
     3. the "(1 844 recenze)" paragraph inside the all-reviews
        header — parse the first digit run

   First hit wins. If none resolve, the count span stays empty and
   the tab shows "Recenze ★" with no number — acceptable fallback.
   ============================================================= */
(function () {
  'use strict';

  var INIT_FLAG = 'data-3n-pdp-tabs-rating-init';

  function parseIntSafe(raw) {
    if (raw == null) return null;
    var cleaned = String(raw).replace(/[\s.,\u00A0]/g, '');
    var n = parseInt(cleaned, 10);
    return isNaN(n) ? null : n;
  }

  function readJudgemeCount() {
    // Source 1: Judge.me's global data object, if it's loaded.
    try {
      var fromGlobal = (window.jdgm &&
        window.jdgm.data &&
        window.jdgm.data.allReviewsWidgetV2025 &&
        window.jdgm.data.allReviewsWidgetV2025.number_of_reviews);
      if (typeof fromGlobal === 'number' && fromGlobal >= 0) return fromGlobal;
    } catch (_) { /* ignore */ }

    // Source 2: any element with a data attribute exposing the count.
    var badge = document.querySelector('[data-number-of-reviews]');
    if (badge) {
      var n = parseIntSafe(badge.getAttribute('data-number-of-reviews'));
      if (n != null) return n;
    }

    // Source 3: parse the paragraph inside the all-reviews widget.
    var paragraphs = document.querySelectorAll(
      '.jdgm-all-reviews-widget-v2025 .jm-average-rating-display__content p'
    );
    for (var i = 0; i < paragraphs.length; i++) {
      var text = paragraphs[i].textContent || '';
      // "(1 844 recenze)" / "(92 reviews)" — first digit run.
      var m = text.match(/([\d\s.,\u00A0]+)/);
      if (m) {
        var parsed = parseIntSafe(m[1]);
        if (parsed != null && parsed >= 0) return parsed;
      }
    }

    return null;
  }

  function applyCount() {
    var slots = document.querySelectorAll('[data-review-count-slot]');
    if (!slots.length) return false;
    var count = readJudgemeCount();
    if (count == null) return false;
    slots.forEach(function (s) {
      s.textContent = '(' + count + ')';
    });
    return true;
  }

  function init() {
    if (document.body.hasAttribute(INIT_FLAG)) return;
    document.body.setAttribute(INIT_FLAG, '');

    // Try once immediately (covers server-side-rendered Judge.me data).
    if (applyCount()) return;

    // Judge.me is typically lazy — watch the DOM until the count appears
    // or we give up. 20s is a generous ceiling; typical hydration < 2s.
    var start = Date.now();
    var observer = new MutationObserver(function () {
      if (applyCount() || Date.now() - start > 20000) {
        observer.disconnect();
      }
    });
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ==========================================================================
   3NODE — Animated underline under section headings
   Clones the reusable #rf-underline-tpl (snippets/rf-underline.liquid) after
   the target heading; the stroke "draws" itself when scrolled into view
   (CSS animates stroke-dashoffset on .is-visible). No JS library needed.
   ========================================================================== */
(function () {
  function observeUnderline(node) {
    if (node.dataset.rfObserved) return;
    node.dataset.rfObserved = '1';
    if ('IntersectionObserver' in window) {
      // Toggle on enter/leave so the loop only runs while in view.
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          node.classList.toggle('is-visible', entry.isIntersecting);
        });
      }, { threshold: 0.2 });
      io.observe(node);
    } else {
      node.classList.add('is-visible');
    }
  }

  function initUnderlines() {
    // Vloží podtržení pod nadpis sekce Instagramu (klon šablony).
    // Dřív patřilo newsletteru; v jeho oranžové variantě ho návrh nemá,
    // zato rám `InstagramFeed` ano — štětec vede pod druhým řádkem.
    var tpl = document.getElementById('rf-underline-tpl');
    if (tpl && tpl.content && tpl.content.firstElementChild) {
      // Klíč sekce se mezi šablonami liší (na homepage je to hash), takže se
      // kotví na blok aplikace, ne na id sekce.
      var headings = document.querySelectorAll(
        '.shopify-section:has([id*="instafeed_app_block"]) .text-block h2'
      );
      Array.prototype.forEach.call(headings, function (h2) {
        if (h2.dataset.rfUnderline) return;
        h2.dataset.rfUnderline = '1';
        var node = tpl.content.firstElementChild.cloneNode(true);
        // Nadpis je dvouřádkový a druhý řádek je v <em>; štětec patří pod něj
        // celý, ne jen pod poslední slovo jako dřív u newsletteru.
        var em = h2.querySelector('em');
        if (em) {
          em.classList.add('rf-uw');
          em.appendChild(node);
          /* Druhý řádek („Z našeho Instagramu") = odkaz na profil (Freelo 32903129).
             Na profil, ze kterého box ukazuje příspěvky (Instafeed = realfoot_shoes);
             patička odkazuje na realfoot.cz. */
          if (!em.closest('a')) {
            var link = document.createElement('a');
            link.className = 'rf-ig-link';
            link.href = 'https://www.instagram.com/realfoot_shoes';
            link.target = '_blank';
            link.rel = 'noopener';
            em.parentNode.insertBefore(link, em);
            link.appendChild(em);
          }
        } else {
          h2.insertAdjacentElement('afterend', node);
        }
      });
    }
    // Animate every underline (injected above + any rendered inline in markup,
    // e.g. the barefoot-comparison section).
    Array.prototype.forEach.call(
      document.querySelectorAll('.rf-underline'),
      observeUnderline
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initUnderlines);
  } else {
    initUnderlines();
  }
})();

/* ==========================================================================
   3NODE — Carousel progress bar (collection-list category carousels)
   Figma "Bar": a dark fill that grows as you scroll toward the last slide.
   Hidden when there's nothing to scroll (all cards fit).
   ========================================================================== */
(function () {
  function attachProgress(scroller, insertAfterEl) {
    if (!scroller || scroller.dataset.rfProgress) return;
    scroller.dataset.rfProgress = '1';

    var bar = document.createElement('div');
    bar.className = 'rf-carousel-progress';
    var fill = document.createElement('div');
    fill.className = 'rf-carousel-progress__fill';
    bar.appendChild(fill);
    (insertAfterEl || scroller).insertAdjacentElement('afterend', bar);

    function update() {
      var max = scroller.scrollWidth - scroller.clientWidth;
      if (max <= 1) {
        bar.style.display = 'none';
        return;
      }
      bar.style.display = '';
      var pct = ((scroller.scrollLeft + scroller.clientWidth) / scroller.scrollWidth) * 100;
      fill.style.width = Math.max(0, Math.min(100, pct)) + '%';
    }

    scroller.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
    // The instafeed app lays out asynchronously — re-check a couple of times.
    setTimeout(update, 500);
    setTimeout(update, 1500);
  }

  function init() {
    // Category carousels (collection-list)
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-testid="collection-list"]'),
      function (section) {
        var scroller = section.querySelector('slideshow-slides');
        var after = section.querySelector('.resource-list__carousel') || scroller;
        attachProgress(scroller, after);
      }
    );
    // Instagram feed (nfcube) — activates when the app is in slider/scroll mode.
    var feed = document.querySelector('#insta-feed .instafeed-new-layout-container');
    if (feed) attachProgress(feed, document.getElementById('insta-feed'));

    // Judge.me reviews cards carousel — native scroll, progress bar below
    // the whole content row (container width). The wrapper is the scroller.
    Array.prototype.forEach.call(
      document.querySelectorAll(
        '.jdgm-horizon-widget[data-block-handle="cards_carousel"] .jdgm-content'
      ),
      function (content) {
        var wrapper = content.querySelector('.jdgm-cards-wrapper');
        if (wrapper) attachProgress(wrapper, content);
      }
    );

    // "Proč Realfoot" (why_realfoot) card carousel — the row is the scroller;
    // progress bar sits just below it (container width, cards bleed past).
    Array.prototype.forEach.call(
      document.querySelectorAll(
        '[id*="why_realfoot"] .group-block-content.layout-panel-flex--row'
      ),
      function (row) {
        attachProgress(row, row);
      }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Judge.me injects its carousel asynchronously — re-run until it appears.
  new MutationObserver(init).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();

/* 3NODE — PDP rating: prepend the average number (e.g. "4.9") before the
   Judge.me preview-badge stars. Judge.me only renders stars + "N hodnocení",
   so we read data-average-rating, round to one decimal, and inject a span.
   Scoped to the buy box (.product-information) so product-card badges are
   untouched. */
(function () {
  'use strict';
  function injectRatingNumbers() {
    var badges = document.querySelectorAll(
      '.product-information .jdgm-prev-badge[data-average-rating]'
    );
    badges.forEach(function (badge) {
      if (badge.querySelector('.rf-rating-num')) return;
      var stars = badge.querySelector('.jdgm-prev-badge__stars');
      if (!stars) return;
      var avg = parseFloat(badge.getAttribute('data-average-rating'));
      if (isNaN(avg) || avg <= 0) return;
      var num = document.createElement('span');
      num.className = 'rf-rating-num';
      num.textContent = avg.toFixed(1);
      badge.insertBefore(num, stars);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectRatingNumbers);
  } else {
    injectRatingNumbers();
  }
  new MutationObserver(injectRatingNumbers).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();

/* 3NODE — Reviews summary: reword "(68 recenze)" -> "na základě 68 recenzí"
   (Figma). Judge.me's count string can't be changed from the theme, so
   rewrite it in the DOM. Scoped to the review-widget summary. */
(function () {
  'use strict';
  function fixCount() {
    // Reword the summary count, bolding the "N recenzí" part.
    document
      .querySelectorAll('.jdgm-review-widget .jm-average-rating-display__content .jm-text')
      .forEach(function (p) {
        if (p.dataset.rfCount) return;
        /* Judge.me píše počet v jazyce stránky: „(11 recenzí)“, „(11 reviews)“, „(11 Bewertungen)“. */
        var m = p.textContent.trim().match(/^\(?\s*(\d+)\s*(?:recenz\w*|reviews?|bewertung\w*)\s*\)?$/i);
        if (m) {
          p.dataset.rfCount = '1';
          p.innerHTML = RF_TEXTY.naZakladeHtml(m[1]);
        }
      });

    // Histogram: replace Judge.me's single star per row with 5 stars,
    // filled orange up to that row's rating (Figma).
    document
      .querySelectorAll('.jdgm-review-widget .jm-histogram-row')
      .forEach(function (row) {
        if (row.dataset.rfStars) return;
        var ratingEl = row.querySelector('.jm-histogram-row__rating');
        var starWrap = row.querySelector('.jm-star-rating');
        if (!ratingEl || !starWrap) return;
        var rating = parseInt(ratingEl.textContent, 10);
        if (isNaN(rating)) return;
        row.dataset.rfStars = '1';
        var starPath =
          'M7.52691 0L9.85273 4.71275L15.0538 5.46875L11.2904 9.13707L12.1788 14.3171L7.52691 11.8714L2.87498 14.3171L3.76346 9.13707L0 5.46875L5.2011 4.71275L7.52691 0Z';
        var html = '';
        for (var i = 1; i <= 5; i++) {
          var paint = i <= rating ? 'fill="#C9A227"' : 'fill="none" stroke="#C9A227"';
          html +=
            '<svg class="rf-hist-star" viewBox="0 0 15.0538 14.3171" xmlns="http://www.w3.org/2000/svg">' +
            '<path d="' + starPath + '" ' + paint + '/></svg>';
        }
        starWrap.innerHTML = html;
      });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fixCount);
  else fixCount();
  new MutationObserver(fixCount).observe(document.documentElement, { childList: true, subtree: true });
})();

/* 3NODE — PDP reviews: rating filter dropdown + toolbar (Figma).
   Lesson learned: reparenting Vue-managed conditional nodes (the filter
   panel) breaks Vue's unmount — the popover gets stuck and re-mounts
   shift the header layout. So the native filters UI stays IN PLACE,
   hidden by CSS; we force-mount the panel once (programmatic click on
   the native "Filtry" toggle) and render OUR OWN popover whose rows
   proxy clicks to the hidden native inputs. The sort <select> (a
   persistent node — safe to move) goes to the toolbar right. */
(function () {
  'use strict';
  var STAR =
    'M7.52691 0L9.85273 4.71275L15.0538 5.46875L11.2904 9.13707L12.1788 14.3171L7.52691 11.8714L2.87498 14.3171L3.76346 9.13707L0 5.46875L5.2011 4.71275L7.52691 0Z';

  function starRow(n) {
    var s = '';
    for (var i = 0; i < n; i++) {
      s += '<svg class="rf-rdd-star" viewBox="0 0 15.0538 14.3171" xmlns="http://www.w3.org/2000/svg">' +
        '<path d="' + STAR + '" fill="#C9A227"/></svg>';
    }
    return s;
  }

  function rework() {
    document.querySelectorAll('.jdgm-review-widget').forEach(function (widget) {
      var header = widget.querySelector('.jm-review-widget__header');
      if (!header) return;

      /* Produkt bez recenzí. Judge.me vykreslí .jdgm-empty-state, ale jeho
         text je prázdný (zpráva prázdného stavu není v aplikaci vyplněná),
         takže na stránce zbyde jen šedý pruh z paddingu hlavičky a pod ním
         náš filtr hodnocení, který nemá co filtrovat.

         .jdgm-empty-state je jediný spolehlivý příznak — kdyby se řídilo
         jen tím, že chybí souhrn hodnocení, označilo by se za prázdný i
         widget, který se teprve načítá, a sekce by problikla. */
      var isEmpty = !!widget.querySelector('.jdgm-empty-state');
      var notReady = !widget.querySelector('.jm-average-rating-display');

      if (isEmpty) {
        var stale = widget.querySelector('.rf-rev-toolbar');
        if (stale) stale.remove();
        widget.classList.add('rf-rev-empty');
        return;
      }
      widget.classList.remove('rf-rev-empty');
      if (notReady) return;

      /* Toolbar below the grey panel */
      var toolbar = widget.querySelector('.rf-rev-toolbar');
      if (!toolbar) {
        toolbar = document.createElement('div');
        toolbar.className = 'rf-rev-toolbar';
        toolbar.innerHTML =
          '<div class="rf-rev-toolbar__left"></div><div class="rf-rev-toolbar__right"></div>';
        header.insertAdjacentElement('afterend', toolbar);
      }
      var left = toolbar.querySelector('.rf-rev-toolbar__left');
      var right = toolbar.querySelector('.rf-rev-toolbar__right');

      /* Force-mount the native panel (it stays hidden in the header).
         Re-boot if the widget ever unmounts it again. */
      var nativeBtn = widget.querySelector('.jm-custom-answer-filter');
      if (nativeBtn && !widget.querySelector('.jm-filter-panel') &&
          nativeBtn.getAttribute('aria-expanded') !== 'true') {
        nativeBtn.click();
      }

      /* Sort select -> toolbar right (persistent node; safe to move) */
      var sort = widget.querySelector('select.jdgm-sort-dropdown, select.jm-sort-filter__select');
      if (sort && !right.contains(sort)) {
        sort.classList.add('rf-rev-sort');
        right.appendChild(sort);
      }

      /* Our own dropdown */
      var dd = left.querySelector('.rf-rating-dd');
      if (!dd) {
        dd = document.createElement('div');
        dd.className = 'rf-rating-dd';
        dd.innerHTML =
          '<button type="button" class="rf-rating-dd__btn" aria-expanded="false" aria-haspopup="true">' + RF_TEXTY.hodnoceni +
          '<svg class="rf-rdd-caret" viewBox="0 0 14 14" aria-hidden="true"><path d="M11 5.5L7 9.5L3 5.5" stroke="currentColor" stroke-width="1.5" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
          '</button><div class="rf-rating-dd__panel"><div class="rf-rating-dd__rows"></div>' +
          '<button type="button" class="rf-rating-dd__clear">' + RF_TEXTY.vymazatFiltry + '</button></div>';
        left.appendChild(dd);
        var btn = dd.querySelector('.rf-rating-dd__btn');
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          var open = dd.classList.toggle('is-open');
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
        document.addEventListener('click', function (e) {
          if (!dd.contains(e.target)) dd.classList.remove('is-open');
        });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') dd.classList.remove('is-open');
        });
        dd.querySelector('.rf-rating-dd__clear').addEventListener('click', function () {
          var clr = widget.querySelector('.jm-filter-panel__clear-btn');
          if (clr) clr.click();
          /* Vue's programmatic reset doesn't fire `change` — sync manually */
          setTimeout(function () { syncChecks(widget, dd); }, 80);
          setTimeout(function () { syncChecks(widget, dd); }, 400);
        });
        widget.addEventListener('change', function () { syncChecks(widget, dd); });
      }

      /* Build proxy rows once the native inputs exist */
      var inputs = widget.querySelectorAll('.jm-rating-filter__tag input');
      var rowsWrap = dd.querySelector('.rf-rating-dd__rows');
      if (inputs.length && rowsWrap.children.length !== inputs.length) {
        rowsWrap.innerHTML = '';
        inputs.forEach(function (input) {
          var n = parseInt(input.value, 10) || 0;
          var row = document.createElement('div');
          row.className = 'rf-rdd-row';
          row.dataset.value = String(n);
          row.innerHTML = '<span class="rf-rdd-check"></span><span class="rf-rdd-stars">' + starRow(n) + '</span>';
          row.addEventListener('click', function () {
            var target = widget.querySelector('.jm-rating-filter__tag input[value="' + n + '"]');
            if (target) target.click();
            setTimeout(function () { syncChecks(widget, dd); }, 50);
          });
          rowsWrap.appendChild(row);
        });
      }
      if (rowsWrap.children.length) syncChecks(widget, dd);
    });
  }

  function syncChecks(widget, dd) {
    dd.querySelectorAll('.rf-rdd-row').forEach(function (row) {
      var input = widget.querySelector('.jm-rating-filter__tag input[value="' + row.dataset.value + '"]');
      row.classList.toggle('is-checked', !!(input && input.checked));
    });
    var clr = widget.querySelector('.jm-filter-panel__clear-btn');
    var ourClr = dd.querySelector('.rf-rating-dd__clear');
    if (ourClr) {
      ourClr.style.display =
        clr && !clr.classList.contains('jm-filter-panel__clear-btn--hidden') ? '' : 'none';
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', rework);
  else rework();
  new MutationObserver(rework).observe(document.documentElement, { childList: true, subtree: true });
})();


/* 3NODE — PDP výběr velikosti jako select (handoff RF UI kit [NEW]).

   Nativní variant-picker zůstává v DOM a jen se schová CSS. Položky
   našeho selectu proklikávají jeho skryté radio inputy, takže vazbu na
   formulář, dostupnost i variantu dál drží Shopify. Je to stejný vzorec
   jako u filtru recenzí výš — u nákupní cesty si vlastní implementaci
   stavu dovolit nechceme.

   "Hlídat" u nedostupné velikosti otevírá Kbite modal pro naskladnění
   (#gw-stock-fulfilled-iframe), ne ten cenový. */
(function () {
  'use strict';

  var BELL =
    '<svg class="rf-ss__bell" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
    '<path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9M13.7 21a2 2 0 0 1-3.4 0"' +
    ' stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  /* Stav velikosti z dlaždice (snippets/rf-availability, data-stock-state) —
     select podle něj barví: předprodej oranžově, ne zeleně jako skladem
     (Freelo 32850809, stejná oranž jako řádek dostupnosti). */
  function stockStateOf(label) {
    var el = label && label.querySelector('.variant-option__stock[data-stock-state]');
    return el ? el.getAttribute('data-stock-state') : '';
  }

  function stockTextOf(label) {
    /* Label má text "42Skladem > 5ks" — číslo je hodnota inputu, zbytek je stav. */
    var input = label.querySelector('input');
    var full = (label.textContent || '').replace(/\s+/g, ' ').trim();
    var size = input ? input.value : '';
    return full.indexOf(size) === 0 ? full.slice(size.length).trim() : full;
  }

  /* Předprodej (Freelo 31610997): dlaždice nese jen „Předprodej", celou větu
     s termínem má v data-note (snippets/rf-availability). Klient chce v selectu
     za zeleným stavem šedě v závorce termín — „Předprodej (odesíláme koncem
     září)". Mimo textContent je schválně: stockTextOf čte text celé dlaždice. */
  function appendNote(el, label) {
    var stock = label.querySelector('.variant-option__stock[data-note]');
    var note = stock ? (stock.getAttribute('data-note') || '').trim() : '';
    if (!note) return;
    el.appendChild(document.createTextNode(' '));
    var span = document.createElement('span');
    span.className = 'rf-ss__note';
    span.textContent = '(' + note.charAt(0).toLowerCase() + note.slice(1) + ')';
    el.appendChild(span);
  }

  function build(picker) {
    if (picker.dataset.rfSelect === '1') return;
    var labels = [].slice.call(picker.querySelectorAll('label'));
    if (!labels.length) return;
    picker.dataset.rfSelect = '1';

    var wrap = document.createElement('div');
    wrap.className = 'rf-ss';

    /* Odkaz "Tabulka velikostí" bydlí uvnitř variant-pickeru. Ten se skrývá,
       takže by odkaz zmizel z detailu — přesouvá se nad select, kde ho má
       i handoff (v řádku s dostupností). Je to prostý <a>, ne uzel řízený
       komponentou, takže se dá bezpečně přemístit. */
    /* Odkaz se hledá podle atributu, ne podle textu. Text je přeložený —
       německé „Größentabelle" regex nechytil, odkaz zůstal ve skrytém
       pickeru a na DE verzi nešel vidět (Freelo 32120077). Regex zůstává
       jen jako pojistka pro starší markup bez atributu. */
    var guide = picker.querySelector('[data-size-chart-open]');
    if (!guide) {
      [].forEach.call(picker.querySelectorAll('a, button'), function (el) {
        if (!guide && /tabulka velikost|size guide|size chart/i.test(el.textContent || '')) guide = el;
      });
    }
    wrap.innerHTML =
      '<button type="button" class="rf-ss__trigger" aria-expanded="false" aria-haspopup="listbox">' +
      '<span class="rf-ss__value"></span>' +
      '<span class="rf-ss__value-stock"></span>' +
      '<svg class="rf-ss__chev" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
      '<path d="m6 9 6 6 6-6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg></button>' +
      '<div class="rf-ss__menu" role="listbox" hidden>' +
      '<div class="rf-ss__group"></div></div>';
    picker.insertAdjacentElement('afterend', wrap);

    /* Řádek nad selectem vzniká vždycky, i bez odkazu na tabulku — jinak
       by se na šablonách s vypnutou tabulkou (ponožky, doplňky) neměla
       kam přestěhovat dostupnost a spadla by zpátky nad výběr velikosti.
       Prázdný řádek schová CSS (`.rf-ss__head:empty`). */
    var head = document.createElement('div');
    head.className = 'rf-ss__head';
    if (guide) head.appendChild(guide);
    wrap.insertBefore(head, wrap.firstChild);

    var trigger = wrap.querySelector('.rf-ss__trigger');
    var value = wrap.querySelector('.rf-ss__value');
    var menu = wrap.querySelector('.rf-ss__menu');
    var group = wrap.querySelector('.rf-ss__group');

    /* Legend obsahuje i odkaz "Tabulka velikostí" — bral se celý a v nadpisu
       skupiny pak stálo "Velikost Tabulka velikostí". Odkazy se odstřihnou. */
    var legend = picker.querySelector('legend, .variant-option__title');
    var legendText = 'Velikost';
    if (legend) {
      var clone = legend.cloneNode(true);
      [].forEach.call(clone.querySelectorAll('a, button'), function (el) {
        el.remove();
      });
      legendText = clone.textContent.replace(/\s+/g, ' ').trim() || 'Velikost';
    }
    var heading = document.createElement('p');
    heading.className = 'rf-ss__heading';
    heading.textContent = legendText;
    group.appendChild(heading);

    labels.forEach(function (label) {
      var input = label.querySelector('input');
      if (!input) return;
      var available = input.getAttribute('data-option-available') === 'true';

      var row = document.createElement('div');
      row.className = 'rf-ss__item' + (available ? '' : ' rf-ss__item--out');
      row.setAttribute('role', 'option');
      row.dataset.value = input.value;

      var num = document.createElement('span');
      num.className = 'rf-ss__num';
      num.textContent = input.value;

      var txt = document.createElement('span');
      txt.className = 'rf-ss__stock';
      txt.textContent = stockTextOf(label);
      if (stockStateOf(label)) txt.setAttribute('data-stock-state', stockStateOf(label));
      appendNote(txt, label);

      row.appendChild(num);
      row.appendChild(txt);

      if (!available) {
        var watch = document.createElement('button');
        watch.type = 'button';
        watch.className = 'rf-ss__watch';
        watch.innerHTML = BELL + '<span>' + RF_TEXTY.hlidat + '</span>';
        watch.addEventListener('click', function (e) {
          e.stopPropagation();
          /* Kbite má na stránce dva modaly a oba jsou zapojené:
               #gw-stock-fulfilled-iframe  "Hlídat dostupnost"  ← tenhle
               #gw-price-drop-iframe       "Hlídat cenu"
             Tlačítko aplikace je vystavené jen pro cenu; naskladnění se
             otevírá stejně jako ono — přepnutím display na iframu.
             Nejdřív se zaškrtne nativní input dané velikosti, aby modal
             dostal správnou variantu. */
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
          var modal = document.getElementById('gw-stock-fulfilled-iframe');
          if (modal) {
            modal.style.display = 'block';
          } else {
            var fallback = document.querySelector('[gw-price-drop]');
            if (fallback) fallback.click();
          }
          sync();
          close();
        });
        row.appendChild(watch);
      } else {
        row.addEventListener('click', function () {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
          input.click();
          sync();
          close();
        });
      }

      group.appendChild(row);
    });

    function sync() {
      var checked = picker.querySelector('input:checked');
      value.textContent = checked ? checked.value : RF_TEXTY.vyberteVelikost;
      wrap.classList.toggle('rf-ss--empty', !checked);
      /* Dlaždice ukazovaly dostupnost všech velikostí naráz; select ji schoval.
         U vybrané velikosti se proto vypisuje i do triggeru, ať se kvůli ní
         nemusí rozbalovat menu. */
      var stockOut = wrap.querySelector('.rf-ss__value-stock');
      if (checked) {
        var lbl = checked.closest('label');
        stockOut.textContent = lbl ? stockTextOf(lbl) : '';
        if (lbl && stockStateOf(lbl)) stockOut.setAttribute('data-stock-state', stockStateOf(lbl));
        else stockOut.removeAttribute('data-stock-state');
        if (lbl) appendNote(stockOut, lbl);
        stockOut.classList.toggle(
          'rf-ss__value-stock--out',
          checked.getAttribute('data-option-available') !== 'true'
        );
      } else {
        stockOut.textContent = '';
        stockOut.removeAttribute('data-stock-state');
      }
      [].forEach.call(group.querySelectorAll('.rf-ss__item'), function (r) {
        r.classList.toggle('rf-ss__item--selected', !!checked && r.dataset.value === checked.value);
        r.setAttribute('aria-selected', !!checked && r.dataset.value === checked.value);
      });
    }

    function open() {
      menu.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
    }
    function close() {
      menu.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
    }

    trigger.addEventListener('click', function () {
      menu.hidden ? open() : close();
    });
    document.addEventListener('click', function (e) {
      if (!wrap.contains(e.target)) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
    /* Varianta se dá změnit i mimo náš select (URL, swatch), tak se drží stav. */
    picker.addEventListener('change', sync);

    /* Návrh nechce předvolenou velikost — motiv vybírá první dostupnou,
       tedy zpravidla nejmenší, a zákazník tak může omylem koupit
       velikost, kterou si nevybral. Předvolba se ruší jen tehdy, když si
       ji nevybral sám odkazem s `?variant=`. Prázdný stav selectu
       existoval už dřív, jen se do něj nikdy nedalo dostat. */
    /* V okně rychlého přidání (karta v kategorii) rozhoduje o předvolbě
       odkaz karty, ne adresa stránky — řeší to hák „rychlé přidání" níž,
       který běží až po tom, co okno dostane obsah. */
    if (!picker.closest('#quick-add-dialog') && location.search.indexOf('variant=') === -1) {
      var predvolene = picker.querySelector('input:checked');
      if (predvolene) predvolene.checked = false;
    }

    picker._rfSync = sync;
    sync();
  }

  /* Po výběru velikosti Horizon překreslí obsah pickeru morphem
     (variant-picker.js → updateVariantPicker). Element pickeru zůstává,
     build() se tedy znovu nespustí, ale legenda se vrátí i s odkazem
     „Tabulka velikostí". Picker je schovaný jen vizuálně (1×1 px), takže
     druhý odkaz by zůstal v pořadí Tabu i ve stromu přístupnosti jako
     neviditelné tlačítko. Po každém překreslení se proto uklidí: když už
     odkaz v .rf-ss__head je, ten ze skrytého pickeru se odstraní, jinak
     se tam přesune. `inert` na pickeru se nepoužívá schválně — select
     mění variantu přes input.click() na jeho skrytých radiech. Drawer
     otevírá delegovaný klik podle atributu, na umístění odkazu nezáleží. */
  function uklidTabulku(picker) {
    var wrap = picker.parentElement && picker.parentElement.querySelector(':scope > .rf-ss');
    var head = wrap && wrap.querySelector('.rf-ss__head');
    if (!head) return;
    [].forEach.call(picker.querySelectorAll('[data-size-chart-open]'), function (el) {
      if (head.querySelector('[data-size-chart-open]')) el.remove();
      else head.appendChild(el);
    });
  }

  function initAll() {
    [].forEach.call(document.querySelectorAll('variant-picker'), function (picker) {
      build(picker);
      uklidTabulku(picker);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
  new MutationObserver(initAll).observe(document.documentElement, { childList: true, subtree: true });
})();

/* 3NODE — bez zvolené velikosti se nedá do košíku.
   Souvisí s vypnutou předvolbou výš: dokud si zákazník velikost nevybere,
   tlačítko vypadá i chová se jako neaktivní a kliknutí místo přidání
   rozbalí select. `disabled` se nepoužívá schválně — na vypnutém tlačítku
   se klik neodchytí a nešlo by na select navést. */
(function () {
  var SEL = 'add-to-cart-component button, button[name="add"]';

  /* Picker, ke kterému tlačítko patří. Karta v kategorii vlastní nemá
     (její „Přidat" je jen u produktů s jednou velikostí) — tu neblokovat.
     V okně rychlého přidání jeho picker, jinak picker detailu mimo okno.
     Dřív se bral první picker na stránce, a ten v okně by po zrušení
     předvolby zablokoval i „Přidat" na kartách (Freelo 32851218). */
  function pickerFor(btn) {
    if (btn.closest('product-card')) return null;
    var dlg = btn.closest('#quick-add-dialog');
    if (dlg) return dlg.querySelector('variant-picker');
    var all = document.querySelectorAll('variant-picker');
    for (var i = 0; i < all.length; i++) {
      if (!all[i].closest('#quick-add-dialog')) return all[i];
    }
    return null;
  }

  function jeVybrano(btn) {
    var picker = pickerFor(btn);
    /* Produkt bez variant (jedna velikost) se nemá čím blokovat. */
    if (!picker || picker.querySelectorAll('input').length < 2) return true;
    return !!picker.querySelector('input:checked');
  }

  /* Karty „Doporučujeme" (sections/product-cross-sell-tabs) mají vlastní
     výběr velikosti a vlastní hlídání (data-cst-require-variant). Dřív je
     blokovala velikost hlavního produktu a klik otevřel výběr bot místo
     přidání ponožek — nechávají se úplně na pokoji. */
  function cizi(btn) {
    return !!btn.closest('.cross-sell-card__form');
  }

  function sync() {
    [].forEach.call(document.querySelectorAll(SEL), function (b) {
      if (cizi(b)) return;
      var ok = jeVybrano(b);
      b.classList.toggle('rf-atc--blocked', !ok);
      b.setAttribute('aria-disabled', ok ? 'false' : 'true');
    });
  }
  window.rfAtcSync = sync;

  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest && e.target.closest(SEL);
      if (!btn || cizi(btn) || btn.getAttribute('aria-disabled') !== 'true') return;
      e.preventDefault();
      e.stopPropagation();
      var scope = btn.closest('#quick-add-dialog') || document;
      var trigger = scope.querySelector('.rf-ss__trigger');
      if (trigger) {
        trigger.click();
        trigger.focus();
      }
    },
    true
  );

  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('variant-picker')) sync();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
  /* Galerie i formulář se překreslují přes Section Rendering API. */
  new MutationObserver(sync).observe(document.documentElement, { childList: true, subtree: true });
})();

/* 3NODE — rychlé přidání z karty v kategorii (Freelo 32851218).
   Tlačítko „Vybrat" na kartě otevře okno s výběrem velikosti. Okno si stáhne
   detail produktu, vloží ho morphem a pak ještě překreslí picker podle
   serveru (quick-add.js → #updateVariantPicker) — server tam zaškrtne první
   dostupnou velikost. Select (.rf-ss) se o tom nedozví, takže psal „Vyberte
   velikost", tlačítko bylo aktivní a do košíku šla nejmenší velikost, kterou
   si zákazník nevybral. Tady se po otevření okna použije stejné pravidlo jako
   na detailu: velikost se nepředvolí, jen když ji nese odkaz karty (filtr
   podle velikosti, snippets/rf-card-url), a select i tlačítko se srovnají
   s tím, co je opravdu zaškrtnuté. */
(function () {
  function settle(keep) {
    var picker = document.querySelector('#quick-add-dialog dialog[open] variant-picker');
    if (!picker) return false;
    if (!keep) {
      [].forEach.call(picker.querySelectorAll('input:checked'), function (i) {
        i.checked = false;
      });
    }
    if (picker._rfSync) picker._rfSync();
    if (window.rfAtcSync) window.rfAtcSync();
    return true;
  }

  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest && e.target.closest('.quick-add__button--choose');
      if (!btn) return;
      var card = btn.closest('product-card');
      var link = card && card.querySelector('a.product-card__link');
      var keep = !!(link && /[?&]variant=/.test(link.getAttribute('href') || ''));
      var start = Date.now();
      /* Okno se otevře až po stažení a vložení obsahu (quick-add.js →
         handleClick), proto se čeká na otevřené okno s pickerem. Krátká
         prodleva nechá doběhnout build() selectu nad novým pickerem. */
      (function wait() {
        if (document.querySelector('#quick-add-dialog dialog[open] variant-picker')) {
          setTimeout(function () {
            settle(keep);
          }, 60);
        } else if (Date.now() - start < 8000) {
          setTimeout(wait, 60);
        }
      })();
    },
    true
  );
})();

/* 3NODE — badge nad hlavní fotkou PDP.
   Snippet galerie je téma-file bez háčku na badge, takže se overlay
   vyrenderuje vedle <media-gallery> a tady se přesune do
   <slideshow-container> — box hlavní fotky, který je position: relative
   a drží sticky chování galerie. */
(function () {
  function place() {
    var badges = document.querySelector('.rf-badges--lg');
    if (!badges) return;
    var box = document.querySelector('media-gallery slideshow-container');
    if (!box || badges.parentElement === box) return;
    box.appendChild(badges);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', place);
  } else {
    place();
  }

  /* Přepnutí varianty překreslí galerii přes Section Rendering API,
     takže overlay je potřeba usadit znovu. */
  var main = document.querySelector('.product-information, main') || document.body;
  new MutationObserver(place).observe(main, { childList: true, subtree: true });
})();

/* 3NODE — dostupnost a "Tabulka velikostí" na jedné řádce nad selectem.
   Handoff je má proti sobě; odkaz na tabulku už bydlí v .rf-ss__head
   (je součástí variant pickeru), tak se do něj přesune i dostupnost. */
(function () {
  function place() {
    var head = document.querySelector('.rf-ss__head');
    var avail = document.querySelector('.product-information .rf-availability');
    if (!head || !avail || avail.parentElement === head) return;
    head.insertBefore(avail, head.firstChild);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', place);
  } else {
    place();
  }

  /* Přepnutí varianty překreslí obojí přes Section Rendering API. */
  var main = document.querySelector('.product-information') || document.body;
  new MutationObserver(place).observe(main, { childList: true, subtree: true });
})();

/* 3NODE — sbalený výběr země ve "Změnit region".
   Handoff má trigger s vlajkou a názvem; seznam tématu (hledání, výběr,
   odeslání) zůstává beze změny, jen se schová do rozbalovacího panelu.
   Výběr země formulář odesílá sám, takže se panel nemusí zavírat. */
(function () {
  function zavri(trigger, panel) {
    panel.hidden = true;
    trigger.setAttribute('aria-expanded', 'false');
  }

  function otevri(trigger, panel) {
    panel.hidden = false;
    trigger.setAttribute('aria-expanded', 'true');
    var hledani = panel.querySelector('input[type="search"]');
    if (hledani) hledani.focus();
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-rf-country-trigger]');

    if (trigger) {
      e.preventDefault();
      var panel = trigger.parentElement.querySelector('[data-rf-country-panel]');
      if (!panel) return;
      if (panel.hidden) otevri(trigger, panel);
      else zavri(trigger, panel);
      return;
    }

    /* Klik mimo trigger i panel zavírá — ale ne klik na zemi uvnitř,
       ten si řeší téma a stránku stejně překreslí. */
    if (e.target.closest('[data-rf-country-panel]')) return;
    document.querySelectorAll('[data-rf-country-trigger]').forEach(function (t) {
      var p = t.parentElement.querySelector('[data-rf-country-panel]');
      if (p && !p.hidden) zavri(t, p);
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-rf-country-trigger]').forEach(function (t) {
      var p = t.parentElement.querySelector('[data-rf-country-panel]');
      if (p && !p.hidden) {
        zavri(t, p);
        t.focus();
      }
    });
  });
})();

/* ---------------------------------------------------------------------
   Pruh kategorií na stránce kolekce (sections/rf-category-carousel
   ve variantě .rf-cc--bar) — posouvání tlačítky.

   Návrh má jen tlačítko doprava; doleva přidáváme taky, bez něj by se
   šlo vrátit jen tažením. Obě se schovají, když na dané straně není kam
   posunout.

   Logika je tady, ne inline v sekci: inline <script> s
   document.currentScript se v Horizonu nechytal spolehlivě, protože
   téma sekce překresluje (filtry, změna stránky) a posluchače tím padaly.
   --------------------------------------------------------------------- */
(function () {
  function nastav(pruh) {
    var track = pruh.querySelector('[data-rf-carousel-track]');
    var prev = pruh.querySelector('[data-rf-cc-nav="prev"]');
    var next = pruh.querySelector('[data-rf-cc-nav="next"]');
    if (!track || !prev || !next || pruh.dataset.rfCcNavReady) return;
    pruh.dataset.rfCcNavReady = '1';

    function sync() {
      // 1 px rezerva: scrollWidth a clientWidth se po zaokrouhlení liší
      // i u pruhu, který se celý vejde.
      var max = track.scrollWidth - track.clientWidth;
      // Zpět je překryv přes pruh — dokud není kam couvat, schová se úplně,
      // ať nezakrývá první dlaždici. Další stojí ve vyhrazeném místě, tam
      // stačí zakázat, nic tím neposkočí.
      prev.parentElement.hidden = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft >= max - 1;
    }

    // Posun po celých dlaždicích, ne o pevný zlomek šířky — jinak se
    // zastaví uprostřed dlaždice a ta zůstane přeťatá.
    function posun(smer) {
      var zacatky = [];
      for (var i = 0; i < track.children.length; i++) {
        zacatky.push(track.children[i].offsetLeft);
      }
      var levy = track.scrollLeft;
      var cil;

      if (smer > 0) {
        // První dlaždice, která se celá nevejde — ta půjde na levou hranu.
        var hrana = levy + track.clientWidth;
        cil = track.scrollWidth;
        for (var j = 0; j < zacatky.length; j++) {
          var pravy = zacatky[j] + track.children[j].offsetWidth;
          if (pravy > hrana + 1 && zacatky[j] > levy + 1) {
            cil = zacatky[j];
            break;
          }
        }
      } else {
        // O stránku zpět, zarovnané na nejbližší začátek dlaždice.
        var zpet = levy - track.clientWidth;
        cil = 0;
        for (var k = 0; k < zacatky.length; k++) {
          if (zacatky[k] >= zpet) {
            cil = zacatky[k];
            break;
          }
        }
      }

      // Kdo má v systému zapnuté omezení pohybu, dostane skok místo animace.
      var bezAnimace =
        window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollTo({ left: cil, behavior: bezAnimace ? 'auto' : 'smooth' });
      // Stav tlačítek nespoléhá jen na událost scroll — u plynulého posunu
      // dorazí až po animaci a některé prohlížeče ji u programového
      // scrollTo nevyšlou vůbec.
      setTimeout(sync, 450);
    }

    prev.addEventListener('click', function () { posun(-1); });
    next.addEventListener('click', function () { posun(1); });
    track.addEventListener('scroll', sync, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(sync).observe(track);
    sync();
  }

  function projdi() {
    document.querySelectorAll('.rf-cc--bar').forEach(nastav);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', projdi);
  } else {
    projdi();
  }
  // Téma překresluje sekce při filtrování — po výměně DOM je potřeba
  // navázat znovu.
  document.addEventListener('shopify:section:load', projdi);
  new MutationObserver(projdi).observe(document.body, { childList: true, subtree: true });
})();

/* ---------------------------------------------------------------------
   Ukazatel postupu u vodorovných pásů (rf-reviews, rf-soles).

   Nativní `slideshow-component` tématu umí jako ovládání jen tečky,
   počitadlo nebo náhledy — ukazatel postupu, který mají oba návrhy, mezi
   nimi není. Pásy proto jedou na obyčejném scrollování a tenhle kód k nim
   dopočítá tmavou část pruhu.

   Hledá `[data-rf-pas]` (posouvaný pás) a `[data-rf-pas-fill]` (tmavá
   část) kdekoliv pod společným rodičem.
   --------------------------------------------------------------------- */
(function () {
  function nastav(sekce) {
    var pas = sekce.querySelector('[data-rf-pas]');
    var fill = sekce.querySelector('[data-rf-pas-fill]');
    if (!pas || !fill || sekce.dataset.rfPasReady) return;
    sekce.dataset.rfPasReady = '1';

    function sync() {
      // Postup, ne posuvník: tmavá část roste zleva podle toho, kolik
      // obsahu už uživatel viděl. Na začátku odpovídá viditelné části
      // pásu (v návrhu 320 z 1232, tedy zhruba čtvrtina), na konci vyplní
      // celou šířku. Kdyby se místo toho jen posouval blok pevné šířky,
      // byl by to druhý posuvník, ne ukazatel postupu.
      // Když není co posouvat (krátký feed, široké okno), pruh nedává smysl —
      // plný pruh by tvrdil, že něco skončilo, i když se nikam nejelo.
      var jePosun = pas.scrollWidth > pas.clientWidth + 1;
      if (fill.parentElement) {
        fill.parentElement.style.visibility = jePosun ? '' : 'hidden';
      }
      if (!jePosun) {
        fill.style.width = '100%';
        return;
      }
      var videno = (pas.scrollLeft + pas.clientWidth) / pas.scrollWidth;
      fill.style.width = (Math.min(1, videno) * 100).toFixed(2) + '%';
    }

    pas.addEventListener('scroll', sync, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(sync).observe(pas);
    sync();
  }

  function projdi() {
    document.querySelectorAll('.rf-rw, .rf-so').forEach(nastav);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', projdi);
  } else {
    projdi();
  }
  document.addEventListener('shopify:section:load', projdi);
})();

/* =============================================================
   Překlady recenzí na detailu produktu (Freelo 32356935).
   Jedna recenze = jeden překlad na celém webu: když k recenzi existuje
   náš překlad (metaobjekt rf_review, JSON #rf-review-translations ze
   snippetu rf-review-translations), vymění se jím text ve widgetu
   Judge.me a schová se jejich tlačítko „přeložit / zobrazit originál".
   Recenze bez našeho překladu nechává na Judge.me.
   Widget si vykresluje Vue sám (stránkování, řazení, jejich překlad),
   proto MutationObserver a opakované použití.
   ============================================================= */
(function () {
  'use strict';

  var zdroj = document.getElementById('rf-review-translations');
  if (!zdroj) return;
  var preklady;
  try {
    preklady = JSON.parse(zdroj.textContent || '{}');
  } catch (e) {
    return;
  }
  if (!preklady || !Object.keys(preklady).length) return;

  function naHtml(text) {
    var div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML.replace(/\n/g, '<br>');
  }

  // Popisky z šablony (CS/EN/DE) — „Přeloženo · Zobrazit originál" (Freelo 33471640).
  var L = {
    prelozeno: zdroj.getAttribute('data-l-translated') || 'Přeloženo',
    original: zdroj.getAttribute('data-l-original') || 'Zobrazit originál',
    preklad: zdroj.getAttribute('data-l-translation') || 'Zobrazit překlad'
  };

  function radek(polozka, telo) {
    var obsah = telo.closest('.jm-review-content') || telo.parentElement;
    var r = obsah.querySelector(':scope > .rf-rev-tr');
    if (r) return r;
    r = document.createElement('p');
    r.className = 'rf-rev-tr';
    var info = document.createElement('span');
    info.textContent = L.prelozeno;
    var tecka = document.createElement('span');
    tecka.setAttribute('aria-hidden', 'true');
    tecka.textContent = ' · ';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'rf-rev-tr__btn';
    btn.addEventListener('click', function () {
      if (polozka.getAttribute('data-rf-original') === '1') polozka.removeAttribute('data-rf-original');
      else polozka.setAttribute('data-rf-original', '1');
      pouzij();
    });
    r.appendChild(info);
    r.appendChild(tecka);
    r.appendChild(btn);
    obsah.appendChild(r);
    return r;
  }

  function pouzij() {
    document.querySelectorAll('[review-uuid]').forEach(function (polozka) {
      var uuid = polozka.getAttribute('review-uuid');
      var zaznam = preklady[uuid];
      if (!zaznam) return;
      var preklad = typeof zaznam === 'string' ? zaznam : zaznam.t;
      var original = typeof zaznam === 'string' ? '' : (zaznam.o || '');
      if (!preklad) return;
      var telo = polozka.querySelector('.jdgm-review-content__body-content') ||
                 polozka.querySelector('.jm-review-content__body');
      if (!telo) return;
      var ukazOriginal = original && polozka.getAttribute('data-rf-original') === '1';
      var html = naHtml(ukazOriginal ? original : preklad);
      /* Porovnává se s tím, co jsme vložili naposled — Judge.me text po svém
         překladu přepíše, pak se vloží znovu, jinak se nic nedělá (bez smyčky). */
      if (telo.getAttribute('data-rf-text') !== html || telo.innerHTML !== html) {
        telo.innerHTML = html;
        telo.setAttribute('data-rf-text', html);
      }
      polozka.setAttribute('data-rf-prelozeno', '1');
      polozka.querySelectorAll('.jdgm-translate-button').forEach(function (btn) {
        var obal = btn.closest('.jm-cluster') || btn;
        obal.style.display = 'none';
      });
      if (original && original !== preklad) {
        var b = radek(polozka, telo).querySelector('.rf-rev-tr__btn');
        var popisek = ukazOriginal ? L.preklad : L.original;
        if (b.textContent !== popisek) b.textContent = popisek;
      }
    });
  }

  /* Krátký timer, ne requestAnimationFrame — ten prohlížeč v kartě na
     pozadí pozastaví a text by se vyměnil až po návratu do karty. */
  var naplanovano = false;
  function naplanuj() {
    if (naplanovano) return;
    naplanovano = true;
    setTimeout(function () {
      naplanovano = false;
      pouzij();
    }, 60);
  }

  pouzij();
  new MutationObserver(naplanuj).observe(document.body, { childList: true, subtree: true, characterData: true });
})();


/* =============================================================
   Kbite (Hlídat dostupnost) — viditelné zavření a jazyk modalu
   Freelo/Figma připomínka Oldřicha 10. 9. 2026.

   Dva problémy, oba uvnitř modalu aplikace:

   1) Křížek nejde vidět. Aplikace ho kreslí jako `float: right`
      se zápornými okraji, takže vypadne ven z bílého boxu, a k tomu
      má `color: #ccc` + `opacity: .5` na ztmaveném pozadí. Uživatel
      pak modal nemá jak zavřít a zůstane v něm.

   2) Modal svítí anglicky, i když aplikace české texty zná.
      `initVar.translateStockWidget()` je překládá správně, ale na
      našem tématu se nikdy nezavolá — vlastní tlačítko aplikace
      schováváme a modal otevíráme sami (viz výběr velikosti výš),
      takže `performTranslation()` proběhne dřív, než modal existuje.

   Modal je <iframe srcdoc>, tedy stejná origin — do jeho dokumentu
   se dá sáhnout. Chytáme okamžik, kdy se iframe zobrazí (aplikace
   jen přepne `display`), a doplníme:
     - styl křížku: černý, v pravém horním rohu uvnitř boxu, 32 px
       klikací plocha,
     - zavření Escapem a klikem mimo box,
     - překlad: nejdřív vlastní překlad aplikace (má ho jen pro cs),
       a co zůstane anglicky, přepíšeme texty z RF_TEXTY. Německá
       verze tak nespadne na angličtinu. Až se do Kbite doplní i de,
       tahle záloha se jen přestane uplatňovat.
   ============================================================= */
(function () {
  'use strict';

  var MODALY = {
    'gw-stock-fulfilled-iframe': { prelozit: 'translateStockWidget', texty: 'dostupnost' },
    'gw-price-drop-iframe': { prelozit: 'translateProceDropWidget', texty: 'cena' }
  };

  var STYL =
    '.close-icon.action-close{' +
    'float:none !important;position:absolute !important;top:8px;right:8px;' +
    'margin:0 !important;padding:0 !important;width:32px;height:32px;' +
    'display:flex;align-items:center;justify-content:center;' +
    'font-size:0 !important;line-height:0 !important;text-shadow:none !important;' +
    'opacity:1 !important;color:#0b0d0f !important;border-radius:50%;}' +
    '.close-icon.action-close::before{content:"\\2715";font-size:18px;font-weight:700;' +
    'line-height:1;color:#0b0d0f;}' +
    '.close-icon.action-close:hover,.close-icon.action-close:focus-visible{' +
    'background:#f1f1f1;outline:none;}' +
    '.modal-container{padding-top:38px !important;}';

  function prelozit(dok, modal) {
    /* Vlastní překlad aplikace — pro jazyk, který v ní nastavený je. */
    if (window.initVar && typeof window.initVar[modal.prelozit] === 'function') {
      try {
        window.initVar[modal.prelozit]();
      } catch (e) {
        /* aplikace překlad nemá, jede se dál na naše texty */
      }
    }

    /* Co zůstalo v angličtině, přepíšeme podle jazyka stránky. Poznáme to
       tak, že aplikace pro tenhle jazyk žádný slovník nemá. */
    var locale = (window.Shopify && window.Shopify.locale) || document.documentElement.lang || '';
    var slovnikAplikace =
      window.initVar && window.initVar.translationJson && window.initVar.translationJson[locale];
    if (slovnikAplikace) return;

    var t = RF_TEXTY.kbite;
    if (!t) return;
    var vlastni = t[modal.texty] || {};
    var nastav = function (selektor, text) {
      var el = dok.querySelector(selektor);
      if (el && text) el.innerText = text;
    };
    nastav('.modal-title', vlastni.heading);
    nastav('.notification-message', vlastni.subheading);
    nastav('.notify-button', vlastni.notifyButtonTitle);
    nastav('.privacy-text', t.privacyText);
    nastav('.gw-success-message .success-text', t.successText);
    nastav('.gw-success-message .close-text', t.successCloseText);
    /* Placeholder je jediné, co má modal navázané na Vue; nadpis, tlačítko
       i text o soukromí jsou v šabloně natvrdo, takže se píše do DOM —
       stejně to dělá i překlad samotné aplikace. */
    var vstup = dok.querySelector('.email-input');
    if (vstup && t.emailPlaceholder) vstup.placeholder = t.emailPlaceholder;
    var vue = dok.defaultView && dok.defaultView.growCampaignPopUp;
    if (vue && t.emailPlaceholder) vue.emailPlaceholder = t.emailPlaceholder;
  }

  /* Hlášku o neplatném e-mailu má aplikace v šabloně natvrdo anglicky —
     i v českém slovníku je pod klíčem `invalidEmailErrorText` uložený
     anglický text. Objeví se až po kliknutí na tlačítko, takže se nedá
     přeložit dopředu; hlídá se, kdy ji Vue vykreslí. */
  function hlidejChyby(dok) {
    var slovnik = RF_TEXTY.kbite && RF_TEXTY.kbite.chyby;
    if (!slovnik) return;
    var box = dok.querySelector('.modal-container');
    if (!box || box.dataset.rfKbiteChyby === '1') return;
    box.dataset.rfKbiteChyby = '1';
    var prelozChyby = function () {
      [].forEach.call(box.querySelectorAll('small'), function (el) {
        var text = (el.textContent || '').trim();
        if (slovnik[text]) el.textContent = slovnik[text];
      });
    };
    prelozChyby();
    new MutationObserver(prelozChyby).observe(box, { childList: true, subtree: true });
  }

  function uprav(iframe, modal) {
    var dok;
    try {
      dok = iframe.contentDocument;
    } catch (e) {
      return;
    }
    if (!dok || !dok.body) return;

    if (!dok.getElementById('rf-kbite-styl')) {
      var styl = dok.createElement('style');
      styl.id = 'rf-kbite-styl';
      styl.textContent = STYL;
      dok.head.appendChild(styl);
    }

    var krizek = dok.querySelector('.close-icon.action-close');
    if (krizek) krizek.setAttribute('aria-label', RF_TEXTY.kbite.zavrit);

    prelozit(dok, modal);
    hlidejChyby(dok);

    if (dok.body.dataset.rfKbite !== '1') {
      dok.body.dataset.rfKbite = '1';
      /* Klik mimo bílý box i Escape zavírají — samotný křížek by na to
         nestačil, aplikace žádnou jinou cestu ven nenabízí. */
      dok.addEventListener('click', function (e) {
        var cil = e.target;
        if (cil && cil.closest && cil.closest('.modal-container')) return;
        zavri(iframe);
      });
      dok.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') zavri(iframe);
      });
    }

    /* Escape z hlavního dokumentu — po otevření modalu v něm fokus být nemusí.
       Podmínka na viditelnost je nutná, jinak by Escape kdekoli na stránce
       volal zavírání modalu, který není otevřený. */
    if (!iframe.dataset.rfKbiteEsc) {
      iframe.dataset.rfKbiteEsc = '1';
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && viditelny(iframe)) zavri(iframe);
      });
    }

    /* Kurzor do e-mailu jen na desktopu — na mobilu by vyskočila klávesnice
       a modal by se schoval za ni. */
    if (window.innerWidth >= 750) {
      var vstup2 = dok.querySelector('.email-input');
      if (vstup2) vstup2.focus();
    }
  }

  function viditelny(iframe) {
    return !!iframe.style.display && iframe.style.display !== 'none';
  }

  function zavri(iframe) {
    if (window.initVar && typeof window.initVar.closePopUp === 'function') {
      window.initVar.closePopUp(iframe.id);
    } else {
      iframe.style.display = 'none';
    }
  }

  function hlidej(iframe, modal) {
    if (iframe.dataset.rfKbite === '1') return;
    iframe.dataset.rfKbite = '1';
    /* Aplikace modal otevírá i zavírá prostým přepnutím `display` na iframu —
       na jinou událost se chytit nedá. */
    new MutationObserver(function () {
      if (viditelny(iframe)) uprav(iframe, modal);
    }).observe(iframe, { attributes: true, attributeFilter: ['style'] });
    if (viditelny(iframe)) uprav(iframe, modal);
  }

  var sledovac = null;
  var hotovo = false;
  function najdi() {
    var vsechny = true;
    Object.keys(MODALY).forEach(function (id) {
      var iframe = document.getElementById(id);
      if (iframe) hlidej(iframe, MODALY[id]);
      else vsechny = false;
    });
    if (!vsechny) return;
    /* Jakmile jsou oba modaly na stránce, sledování DOM končí — dál už si
       vystačíme s pozorovatelem na `style` každého iframu. */
    hotovo = true;
    if (sledovac) {
      sledovac.disconnect();
      sledovac = null;
    }
  }

  /* Skript aplikace se načítá až po nás a iframy vkládá do <body> později.
     Přeplánování přes timer, ať se na stránce plné překreslování (recenze,
     filtry) nevolá `najdi` po každé jednotlivé změně. */
  var naplanovano = false;
  function naplanuj() {
    if (naplanovano) return;
    naplanovano = true;
    setTimeout(function () {
      naplanovano = false;
      najdi();
    }, 60);
  }

  najdi();
  if (!hotovo) {
    sledovac = new MutationObserver(naplanuj);
    sledovac.observe(document.documentElement, { childList: true, subtree: true });
  }
})();


/* =============================================================
   Hlavní menu — přepočítat „Více" po načtení písma
   Připomínka klienta 19. 9. 2026 („review how menu wraps").

   `<overflow-list>` schová položky, které se do řádku nevejdou, pod
   tlačítko „Více". Rozhoduje se podle skutečné šířky položek — jenže
   měří hned po vykreslení, tedy ještě v náhradním písmu. Jakmile
   doskočí Transducer, texty se roztáhnou, ale komponenta se o tom
   nedozví: `ResizeObserver` sleduje sebe (a ta se nezměnila) a
   `MutationObserver` jen přibývání a ubývání potomků.

   Výsledek na šířkách kolem 1000, 900 a 800 px: v řádku zůstane o jednu
   položku víc, než se vejde, a tlačítko „Více" se zalomí na druhý řádek
   pod hlavičku — visí přes obrázek. Po jakékoli změně šířky okna se to
   samo spraví, protože přepočet proběhne znovu.

   Komponenta na sobě poslouchá událost `reflow`, tak jí ji po načtení
   písem pošleme. Detail musí být objekt — komponenta z něj čte
   `lastVisibleElement`.
   ============================================================= */
(function () {
  'use strict';

  function prepocitat() {
    document.querySelectorAll('overflow-list').forEach(function (el) {
      el.dispatchEvent(new CustomEvent('reflow', { detail: {} }));
    });
  }

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(prepocitat);
  } else {
    window.addEventListener('load', prepocitat);
  }
})();

/* =============================================================
   3NODE — Lupa galerie na PDP (detail fotky).

   Horizon na desktopu skládá všechny fotky pod sebe přes celou
   šířku okna a řeže je (`cover`), takže packshot na bílém vypadá
   jako prázdná bílá obrazovka a vysoká fotka se do okna nevejde.
   Michal 22. 9.: „obrázek má být contain a mají fungovat šipky".

   Rozvržení řeší CSS (assets/custom.css.liquid, sekce „Lupa
   galerie"); tady je jen ovládání: šipky vlevo/vpravo a klávesy
   ←/→ (a PageUp/PageDown). Posouvá se po celých obrazovkách,
   protože každá fotka má v lupě výšku okna.

   Šipky se vkládají do <dialog> v <zoom-dialog>; index se počítá
   z pozice posunu, takže není potřeba sahat do zoom-dialog.js.
   ============================================================= */
(function () {
  'use strict';

  var SIPKA_ZPET =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="15 18 9 12 15 6"/></svg>';
  var SIPKA_VPRED =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="9 18 15 12 9 6"/></svg>';

  function pocetFotek(dialog) {
    return dialog.querySelectorAll('.dialog-zoomed-gallery > .product-media-container').length;
  }

  function aktivniIndex(dialog) {
    var vyska = dialog.clientHeight;
    if (!vyska) return 0;
    return Math.round(dialog.scrollTop / vyska);
  }

  function prejit(dialog, smer) {
    var polozky = dialog.querySelectorAll('.dialog-zoomed-gallery > .product-media-container');
    if (polozky.length < 2) return;

    var cil = aktivniIndex(dialog) + smer;
    /* Dokola: z poslední na první a naopak — v lupě není kam jinam jít. */
    if (cil < 0) cil = polozky.length - 1;
    if (cil > polozky.length - 1) cil = 0;

    var komponenta = dialog.closest('zoom-dialog');
    /* Komponenta tématu srovná i náhledy vpravo a donačte velkou fotku. */
    if (komponenta && typeof komponenta.selectThumbnail === 'function') {
      komponenta.selectThumbnail(cil);
    } else {
      polozky[cil].scrollIntoView({ behavior: 'smooth' });
    }
  }

  function stavSipek(dialog) {
    var skryt = pocetFotek(dialog) < 2;
    dialog.querySelectorAll('.rf-zoom-nav').forEach(function (b) {
      b.hidden = skryt;
    });
  }

  function vlozSipky(dialog) {
    if (dialog.querySelector('.rf-zoom-nav')) return;

    [
      ['prev', -1, SIPKA_ZPET],
      ['next', 1, SIPKA_VPRED],
    ].forEach(function (def) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'rf-zoom-nav rf-zoom-nav--' + def[0];
      b.innerHTML = def[2];
      b.setAttribute('aria-label', def[0] === 'prev' ? 'Předchozí fotka' : 'Další fotka');
      b.addEventListener('click', function (e) {
        /* Klik do plochy lupu zavírá (cursor: zoom-out), šipka ne. */
        e.stopPropagation();
        e.preventDefault();
        prejit(dialog, def[1]);
      });
      dialog.appendChild(b);
    });

    stavSipek(dialog);
  }

  function obsluhaKlaves(e) {
    var dialog = document.querySelector('.dialog-zoomed-gallery__dialog[open]');
    if (!dialog) return;

    var smer = 0;
    if (e.key === 'ArrowLeft' || e.key === 'ArrowUp' || e.key === 'PageUp') smer = -1;
    if (e.key === 'ArrowRight' || e.key === 'ArrowDown' || e.key === 'PageDown') smer = 1;
    if (!smer) return;

    e.preventDefault();
    prejit(dialog, smer);
  }

  function start() {
    document.querySelectorAll('.dialog-zoomed-gallery__dialog').forEach(vlozSipky);
    document.addEventListener('keydown', obsluhaKlaves);

    /* Varianty mění obsah galerie (section rendering), takže se
       dialog může přegenerovat i po načtení stránky. */
    var mo = new MutationObserver(function () {
      document.querySelectorAll('.dialog-zoomed-gallery__dialog').forEach(function (d) {
        vlozSipky(d);
        stavSipek(d);
      });
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* =============================================================
   3NODE — Filtry na kolekci: na desktopu nic neschovávat.

   Oldřich 23. 9. 2026 (Freelo 32663244): „Rád bych, aby byly
   rozbalené všechny filtry, aby se to tam vešlo a nic se
   neschovávalo."

   Téma dává filtry do komponenty overflow-list, která změří řádek
   a co se nevejde, odsune do skrytého slotu za tlačítko „Filtry".
   Na desktopu komponentě řekneme `showAll()` — ta vrátí položky
   zpět do řádku, schová placeholder a přestane měřit. Zalomení na
   druhý řádek pak řeší CSS v blocks/filters.liquid.

   Pojistka: kdyby `showAll()` doběhlo dřív, než komponenta poprvé
   přeskládá položky, zůstaly by některé ve slotu `overflow`
   (a tím neviditelné) — proto je z něj ještě ručně vracíme
   a kontrolu po chvíli zopakujeme.

   Na mobilu zůstává chování tématu (filtry jsou v zásuvce).
   ============================================================= */
(function () {
  'use strict';

  var OD_DESKTOPU = 750;

  function vratPolozky(el) {
    var vraceno = false;
    Array.prototype.forEach.call(el.children, function (dite) {
      if (dite.getAttribute('slot') === 'overflow') {
        dite.removeAttribute('slot');
        vraceno = true;
      }
    });
    return vraceno;
  }

  function rozbal(el) {
    if (typeof el.showAll === 'function') {
      try {
        el.showAll();
      } catch (e) {
        /* Komponenta ještě není inicializovaná — zkusíme to znovu níž. */
      }
    }
    return vratPolozky(el);
  }

  function prepni() {
    var desktop = window.innerWidth >= OD_DESKTOPU;

    document.querySelectorAll('overflow-list.facets__overflow-list').forEach(function (el) {
      if (desktop) {
        rozbal(el);
      } else if (el.hasAttribute('disabled')) {
        el.removeAttribute('disabled');
      }
    });
  }

  function start() {
    prepni();
    /* Komponenta se inicializuje až po načtení svých stylů a pak jednou
       přeskládá položky — po těchto krocích kontrolu zopakujeme. */
    [100, 400, 1200].forEach(function (ms) {
      setTimeout(prepni, ms);
    });
    window.addEventListener('load', prepni);

    var timer;
    window.addEventListener('resize', function () {
      clearTimeout(timer);
      timer = setTimeout(prepni, 150);
    });

    /* Po filtrování se sekce překreslí (section rendering), takže přijde
       nová komponenta. */
    var mo = new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(prepni, 60);
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* Odkaz „Nastavení cookies" v patičce (href="#cookie-settings", i v překladech)
   otevře předvolby nativní Shopify cookie lišty. Bez toho odkaz nedělal nic a souhlas
   nešlo změnit ani odvolat. privacyBanner existuje jen tam, kde se lišta načítá. */
document.addEventListener('click', function (e) {
  var a = e.target.closest && e.target.closest('a[href="#cookie-settings"]');
  if (!a) return;
  e.preventDefault();
  if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
    window.privacyBanner.showPreferences();
  }
});

/* Newsletter (blok email-signup: patička, HP, kolekce) → rovnou do Ecomailu
   (Freelo 32878492). Konfiguraci (seznam, zdroj, texty) vypisuje snippet
   rf-ecomail podle trhu a jazyka. Kontakt tak dostane zdroj, na který reaguje
   welcome automatizace s kupónem. Když Ecomail neodpoví, odešle se původní
   Shopify formulář, aby se přihlášení neztratilo. */
document.addEventListener('submit', function (e) {
  var form = e.target;
  var cfg = window.rfEcomailSignup;
  if (!cfg || !form.matches || !form.matches('form.email-signup__form')) return;
  if (form.dataset.rfFallback) return;
  var input = form.querySelector('input[type="email"]');
  if (!input) return;
  e.preventDefault();
  if (form.dataset.rfSending) return;
  form.dataset.rfSending = '1';
  var button = form.querySelector('button');
  if (button) button.disabled = true;

  function show(text, ok) {
    var old = form.querySelector('.rf-newsletter-msg');
    if (old) old.remove();
    var msg = document.createElement('div');
    msg.className = 'email-signup__message rf-newsletter-msg' + (ok ? '' : ' rf-newsletter-msg--error');
    msg.setAttribute('role', ok ? 'status' : 'alert');
    var p = document.createElement('p');
    p.className = 'email-signup__message-text';
    p.textContent = text;
    msg.appendChild(p);
    form.appendChild(msg);
  }
  function done() {
    delete form.dataset.rfSending;
    if (button) button.disabled = false;
  }

  /* Pole „email" + „custom_source" (zdroj kontaktu = formulář, např. staticky2).
     Ecomail starší pole widgetu ecmw[email] už nebere — vrací „Neplatný e-mail"
     i pro platnou adresu (zjištěno 21. 10. 2026, Freelo 33340479). Bez vlastních
     hlaviček = „jednoduchý" CORS požadavek bez preflightu, Ecomail vrací ACAO *
     a JSON {success, message}. */
  fetch(cfg.url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body:
      'email=' + encodeURIComponent(input.value.trim()) +
      '&custom_source=' + encodeURIComponent(cfg.source)
  })
    .then(function (r) { return r.json(); })
    .then(function (d) {
      done();
      if (d && d.success) {
        input.value = '';
        show(cfg.doi ? cfg.msg.confirm : cfg.msg.success, true);
      } else if (d && /registrov/i.test(d.message || '')) {
        /* „Tento e-mail je již registrován" — už odebírá, není to chyba. */
        show(cfg.msg.already, true);
      } else {
        show(cfg.msg.error, false);
      }
    })
    .catch(function () {
      done();
      form.dataset.rfFallback = '1';
      if (form.requestSubmit) form.requestSubmit(); else form.submit();
    });
});

/* ===== Newsletter: číslo a jednotka na jednom řádku (Freelo 32400009) =====
   Nadpis boxu („Získejte 200 kč slevu…") se na mobilu i na velkých monitorech lámal
   mezi „200" a „kč". Text je v nastavení sekce a je přeložený (EN/DE + trh US), proto
   ho ve zdroji neměníme (zneplatnil by překlady) — pevnou mezeru doplníme tady,
   pro všechny jazyky a trhy: „200 Kč", „8 EUR", „10 %", „100 $". */
(function () {
  var RE = /(\d)[  ]+(kč|Kč|EUR|€|%|\$)/g;
  function fix(root) {
    (root || document).querySelectorAll('[id*="newsletter"] p, [id*="newsletter"] h2').forEach(function (el) {
      var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
      var node;
      while ((node = walker.nextNode())) {
        var text = node.data.replace(RE, function (m, num, unit) {
          return num + ' ' + (unit === 'kč' ? 'Kč' : unit);
        });
        if (text !== node.data) node.data = text;
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { fix(); });
  else fix();
  document.addEventListener('shopify:section:load', function (e) { fix(e.target); });
})();
